import { createStore } from 'vuex'
import { login, loginWithDirect, loginPlusWithSMS, getUserInfo } from '@/api/base'
import { getFrontExamUserDetail } from '@/api/user/examUser.js'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'

const store = createStore({
  state: {
    token: getToken() || '',
    userId: null,
    sysUserId: null,
    userName: null,
    sysNickName: null,
    nickName: null,
    avatar: null,
    roles: [],
    permissions: [],
    websocket: null // 全局 WebSocket 实例
  },
  
  getters: {
    // 为了兼容性，提供 user 对象的 getter
    user: (state) => ({
      userId: state.userId,
      sysUserId: state.sysUserId,
      userName: state.userName,
      sysNickName: state.sysNickName,
      nickName: state.nickName,
      avatar: state.avatar,
      token: state.token
    })
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    
    SET_USER_ID(state, userId) {
      state.userId = userId
    },
    
    SET_SYS_USER_ID(state, sysUserId) {
      state.sysUserId = sysUserId
    },
    
    SET_USER_NAME(state, userName) {
      state.userName = userName
    },
    
    SET_SYS_NICK_NAME(state, nickName) {
      state.sysNickName = nickName
    },
    
    SET_NICK_NAME(state, nickName) {
      state.nickName = nickName
    },
    
    SET_AVATAR(state, avatar) {
      state.avatar = avatar
    },
    
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },

    CLEAR_USER(state) {
      state.token = ''
      state.userId = null
      state.sysUserId = null
      state.userName = null
      state.sysNickName = null
      state.nickName = null
      state.avatar = null
      state.roles = []
      state.permissions = []
      removeToken()
    },
    
    SET_WEBSOCKET(state, websocket) {
      state.websocket = websocket
    },
    
    CLOSE_WEBSOCKET(state) {
      if (state.websocket) {
        state.websocket.closeSocket(1000, '路由离开，关闭连接')
        state.websocket = null
      }
    }
  },
  
  actions: {
    // 学号密码登录
    async loginWithDirect({ commit, dispatch }, loginForm) {
      return new Promise((resolve, reject) => {
        loginWithDirect({
          userName: loginForm.studentNo,
          password: loginForm.password,
          code: loginForm.code,
          uuid: loginForm.uuid,
          loginType: 'gaozhi-enroll-exam'
        })
          .then((res) => {
            const { code, data } = res
            if (code === 200) {
              setToken(data)
              commit('SET_TOKEN', data)
              ElMessage.success('登录成功')
              // 获取用户信息
              dispatch('GetUserSysInfo')
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    
    // 手机验证码登录（考试系统专用）
    async LoginWithSMSForExam({ commit, dispatch }, loginForm) {
      return new Promise((resolve, reject) => {
        loginPlusWithSMS({
          userName: loginForm.userName,
          smsCode: loginForm.smsCode,
          uuid: loginForm.uuid,
          code: loginForm.code
        })
          .then((res) => {
            const { code, data } = res
            if (code === 200) {
              setToken(data)
              commit('SET_TOKEN', data)
              ElMessage.success('登录成功')
              // 获取用户信息
              dispatch('GetUserSysInfo')
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    
    // 获取系统用户信息
    async GetUserSysInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (res.code === 200) {
              commit('SET_PERMISSIONS', res.permissions || [])
              commit('SET_USER_NAME', res.user.userName)
              commit('SET_SYS_NICK_NAME', res.user.nickName)
              commit('SET_SYS_USER_ID', res.user.userId)
              commit('SET_ROLES', res.roles || [])
              
              // 获取志愿用户信息
              dispatch('GetExamUserInfo')
              
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    
    // 获取志愿用户信息
    async GetExamUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getFrontExamUserDetail()
          .then((res) => {
            if (res.code === 200 && res.data) {
              const user = res.data
              // 设置 nickName 为 examUserName
              commit('SET_NICK_NAME', user.examUserName)
              commit('SET_USER_ID', user.examUserId)
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            console.error('获取志愿用户信息失败:', error)
            reject(error)
          })
      })
    },
    
    // 退出登录
    logout({ commit }) {
      commit('CLOSE_WEBSOCKET')
      commit('CLEAR_USER')
    },
    
    // 设置 WebSocket 实例
    setWebSocket({ commit }, websocket) {
      commit('SET_WEBSOCKET', websocket)
    },
    
    // 关闭 WebSocket 连接
    closeWebSocket({ commit }) {
      commit('CLOSE_WEBSOCKET')
    }
  }
})

export default store
